/** Client-side validation for template drafts and settings patches. */

export const LEAD_STAGE_OPTIONS = [
  { value: 'new', label: 'New' },
  { value: 'contacted', label: 'Contacted' },
  { value: 'qualified', label: 'Qualified' },
  { value: 'negotiation', label: 'Negotiation' },
  { value: 'closure', label: 'Closure' },
  { value: 'junk', label: 'Junk' },
  { value: 'archived', label: 'Archived' },
];

const VALID_STAGES = new Set(LEAD_STAGE_OPTIONS.map((o) => o.value));

export function validateTemplateDraft(draft) {
  const errors = {};
  const body = (draft?.body || '').trim();
  const isCustom = draft?.templateType === 'custom';
  const isChannelDefault = !!draft?.isChannelDefault;

  if (!isCustom && draft?.templateType === 'comment_reply' && !body) {
    errors.body = 'Comment reply message is required.';
  }

  if (!isCustom && draft?.templateType === 'comment_dm' && !body) {
    errors.body = 'Direct message text is required.';
  }

  if (!isCustom && draft?.templateType === 'dm_reply' && !body) {
    errors.body = 'Auto-reply message is required.';
  }

  if (isCustom) {
    if (!(draft?.name || '').trim()) {
      errors.name = 'Template name is required.';
    }
    if (!body) {
      errors.body = 'Reply message is required.';
    }
    if (!isChannelDefault) {
      // Channel-default templates do not need keywords — they fire on everything
      const keywords = normalizeKeywords(draft?.keywords);
      if (!keywords.length) {
        errors.keywords = 'Add at least one keyword (comma-separated).';
      }
    }
    if (!draft?.triggerChannel) {
      errors.triggerChannel = 'Select a trigger channel.';
    }
  }

  if (body.length > 4000) {
    errors.body = 'Message is too long (max 4000 characters).';
  }

  if (draft?.name && draft.name.length > 255) {
    errors.name = 'Name is too long (max 255 characters).';
  }

  return { valid: Object.keys(errors).length === 0, errors };
}

function normalizeKeywords(keywords) {
  if (!keywords) return [];
  if (Array.isArray(keywords)) return keywords.map((k) => String(k).trim()).filter(Boolean);
  return String(keywords).split(',').map((k) => k.trim()).filter(Boolean);
}

export function validateCustomCreatePayload(payload) {
  return validateTemplateDraft({ ...payload, templateType: 'custom' });
}

export function validateSettingsPatch(settings) {
  const errors = {};

  if (settings?.leadStageOnComment && !VALID_STAGES.has(settings.leadStageOnComment)) {
    errors.leadStageOnComment = 'Invalid lead stage for comments.';
  }

  if (settings?.leadStageOnDm && !VALID_STAGES.has(settings.leadStageOnDm)) {
    errors.leadStageOnDm = 'Invalid lead stage for DMs.';
  }

  return { valid: Object.keys(errors).length === 0, errors };
}

export function getLeadStageLabel(value) {
  return LEAD_STAGE_OPTIONS.find((o) => o.value === value)?.label || value || 'New';
}
